import client from './sanityClient';

export function fetchFromSanity(query) {
  return client.fetch(query);
}
